import {
  AlertTriangle,
  Archive,
  Bell,
  BellRing,
  Bold,
  Bookmark,
  BriefcaseBusiness,
  Building2,
  Calendar,
  Check,
  CheckCircle2,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  Clapperboard,
  CodeXml,
  Database,
  Download,
  Eye,
  FileMusic,
  FileText,
  Film,
  Flag,
  Globe,
  GraduationCap,
  Grid2X2,
  Image,
  Inbox,
  Italic,
  Link,
  List,
  ListOrdered,
  ListTree,
  LogOut,
  type LucideIcon,
  Mail,
  Menu,
  MessageSquare,
  Newspaper,
  Palette,
  Pencil,
  Pilcrow,
  Plus,
  PlusCircle,
  Quote,
  RotateCcw,
  Save,
  School,
  ScrollText,
  Search,
  Send,
  Settings,
  Shield,
  SlidersHorizontal,
  Smartphone,
  Trash2,
  TrendingUp,
  Tv,
  Upload,
  User,
  UserPlus,
  Users,
  Video,
  X
} from 'lucide-react';

export const adminIconMap: Record<string, LucideIcon> = {
  archive: Archive,
  'alert-triangle': AlertTriangle,
  bell: Bell,
  'bell-ring': BellRing,
  bookmark: Bookmark,
  bold: Bold,
  briefcase: BriefcaseBusiness,
  'building-2': Building2,
  calendar: Calendar,
  check: Check,
  'check-circle-2': CheckCircle2,
  'check-square': CheckSquare,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevrons-left': ChevronsLeft,
  clapperboard: Clapperboard,
  'code-xml': CodeXml,
  database: Database,
  download: Download,
  eye: Eye,
  'file-music': FileMusic,
  'file-text': FileText,
  film: Film,
  flag: Flag,
  globe: Globe,
  'graduation-cap': GraduationCap,
  grid: Grid2X2,
  image: Image,
  inbox: Inbox,
  italic: Italic,
  link: Link,
  list: List,
  'list-ordered': ListOrdered,
  'list-tree': ListTree,
  'log-out': LogOut,
  mail: Mail,
  menu: Menu,
  'message-square': MessageSquare,
  newspaper: Newspaper,
  palette: Palette,
  pilcrow: Pilcrow,
  pencil: Pencil,
  plus: Plus,
  'plus-circle': PlusCircle,
  quote: Quote,
  'rotate-ccw': RotateCcw,
  save: Save,
  school: School,
  scroll: ScrollText,
  'scroll-text': ScrollText,
  search: Search,
  send: Send,
  settings: Settings,
  shield: Shield,
  'sliders-horizontal': SlidersHorizontal,
  smartphone: Smartphone,
  'trash-2': Trash2,
  'trending-up': TrendingUp,
  tv: Tv,
  upload: Upload,
  user: User,
  'user-plus': UserPlus,
  users: Users,
  video: Video,
  x: X
};

/**
 * Возвращает lucide-иконку по ключу из HTML NAV.
 * @param key Ключ иконки
 */
export const getAdminIcon = (key: string) => adminIconMap[key] || Grid2X2;
